import { render, staticRenderFns } from "./StatsTeamAcquisitions.vue?vue&type=template&id=5a37c239&scoped=true&"
import script from "./StatsTeamAcquisitions.vue?vue&type=script&lang=js&"
export * from "./StatsTeamAcquisitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37c239",
  null
  
)

export default component.exports